export { default as buildHeader } from './buildHeader';
export { default as buildRowData } from './buildRowData';
export { default as cellRenderer } from './cellRenderer';
export { default as getAgColumns } from './getAgColumns';
export { default as getApplicableFootnotes } from './getApplicableFootnotes';
export { default as getDataRankings } from './getDataRankings';
export { default as filterByRow } from './filterByRow';
export { default as valueGetter } from './valueGetter';



// WEBPACK FOOTER //
// ../datacenter/app/js/services/table/index.js